import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/user/mutationTypes';

export default {
  [types.SET_LOADING_VALIDATION]: createSetPropMutation('loadingValidation', false),
  [types.CLEAR_LOADING_VALIDATION]: createSetPropMutation('loadingValidation', false),
  [types.SET_SERVICE_PROVIDER_EMPLOYEE_ID]: createSetPropMutation('chosenSPEmployeeId', null),
  [types.CLEAR_SERVICE_PROVIDER_EMPLOYEE_ID]: createClearPropMutation('chosenSPEmployeeId', null),
  [types.SET_CURRENT_SP_EMPLOYEE]: createSetPropMutation('currentSPEmployee', {}),
  [types.SET_SP_EMPLOYEE_BEFORE_EDIT]: createSetPropMutation('spEmployeeBeforeEdit', {}),
  [types.SET_SERVICE_PROVIDERS_OF_COMPANY]: createSetPropMutation('serviceProvidersOfCompanyList', []),
  [types.CLEAR_SERVICE_PROVIDERS_OF_COMPANY]: createClearPropMutation('serviceProvidersOfCompanyList', []),
  [types.SET_SERVICE_PROVIDER_FREELANCER_PROFILE]: createSetPropMutation('serviceProviderFreelancerProfileDetails', {}),
  [types.CLEAR_SERVICE_PROVIDER_FREELANCER_PROFILE]: createClearPropMutation('serviceProviderFreelancerProfileDetails', {}),
  [types.SET_SERVICE_PROVIDER_COMPANY_PROFILE]: createSetPropMutation('serviceProviderCompanyProfileDetails', {}),
  [types.CLEAR_SERVICE_PROVIDER_COMPANY_PROFILE]: createClearPropMutation('serviceProviderCompanyProfileDetails', {}),
  [types.SET_SERVICE_PROVIDER_WORKER_PROFILE]: createSetPropMutation('serviceProviderWorkerProfileDetails', {}),
  [types.CLEAR_SERVICE_PROVIDER_WORKER_PROFILE]: createClearPropMutation('serviceProviderWorkerProfileDetails', {}),
  [types.SET_COMPANY_CUSTOMER_PROFILE_DETAILS]: createSetPropMutation('companyCustomerProfileDetails', {}),
  [types.CLEAR_COMPANY_CUSTOMER_PROFILE_DETAILS]: createClearPropMutation('companyCustomerProfileDetails', {}),
  [types.CLEAR_CUSTOMER_PROFILE_DETAILS]: createClearPropMutation('customerProfileDetails', {}),
  [types.SET_CUSTOMER_PROFILE_DETAILS]: createSetPropMutation('customerProfileDetails', {}),
  [types.SET_IS_SERVICE_PROVIDER]: createSetPropMutation('isServiceProvider', false),
  [types.SET_USERS]: createSetPropMutation('users', []),
  [types.CLEAR_USERS]: createClearPropMutation('users', []),
  [types.SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS]: createSetPropMutation('companyCustomerFullIndustriesOptions', []),
  [types.SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS_LOADING]: createSetPropMutation('companyCustomerFullIndustriesOptionsLoading', null),
  [types.SET_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS_LOADING_ERRORS]: createSetPropMutation('companyCustomerFullIndustriesOptionsLoadingErrors', null),
  [types.SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS]: createSetPropMutation('companyCustomerFullRegionsOptions', []),
  [types.SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS_LOADING]: createSetPropMutation('companyCustomerFullRegionsOptionsLoading', null),
  [types.SET_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS_LOADING_ERRORS]: createSetPropMutation('companyCustomerFullRegionsOptionsLoadingErrors', null),
  [types.SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS]: createSetPropMutation('companyCustomerFullRegulationsOptions', []),
  [types.SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS_LOADING]: createSetPropMutation('companyCustomerFullRegulationsOptionsLoading', null),
  [types.SET_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS_LOADING_ERRORS]: createSetPropMutation('companyCustomerFullRegulationsOptionsLoadingErrors', null),
  [types.SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS]: createSetPropMutation('serviceProviderCompanyFullServicesOptions', []),
  [types.SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS_LOADING]: createSetPropMutation('serviceProviderCompanyFullServicesOptionsLoading'),
  [types.SET_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS_LOADING_ERRORS]: createSetPropMutation('serviceProviderCompanyFullServicesOptionsLoadingErrors'),
  [types.SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS]: createSetPropMutation('serviceProviderCompanyFullRegionsOptions', []),
  [types.SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS_LOADING]: createSetPropMutation('serviceProviderCompanyFullRegionsOptionsLoading'),
  [types.SET_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS_LOADING_ERRORS]: createSetPropMutation('serviceProviderCompanyFullRegionsOptionsLoadingErrors'),
  [types.SET_USERS_LIST_OPTIONS](state, options = {}) {
    state.userListOptions = {
      ...state.userListOptions || {},
      ...options,
    };
  },
  [types.SET_TENANT_USERS]: createSetPropMutation('tenantUsers', []),
  [types.CLEAR_TENANT_USERS]: createClearPropMutation('tenantUsers', []),
  [types.SET_PENDING_USERS]: createSetPropMutation('pendingUsers', []),
  [types.CLEAR_PENDING_USERS]: createClearPropMutation('pendingUsers', []),
  [types.SET_TENANT_USERS_LIST_OPTIONS](state, options = {}) {
    state.tenantUsersListOptions = {
      ...state.tenantUsersListOptions || {},
      ...options,
    };
  },
  [types.SET_DOMAINS]: createSetPropMutation('domains', []),
  [types.CLEAR_DOMAINS]: createClearPropMutation('domains', []),
  [types.SET_DOMAINS_LIST_OPTIONS](state, options = {}) {
    state.domainsListOptions = {
      ...state.domainsListOptions || {},
      ...options,
    };
  },
  [types.SET_DISABLE_DELETE_USER_BUTTON](state, newValue) {
    const updatedSet = new Set(state.disableDeleteUserButton);
    if (updatedSet.has(newValue)) {
      updatedSet.delete(newValue);
    } else {
      updatedSet.add(newValue);
    }
    state.disableDeleteUserButton = updatedSet;
  },
  [types.SET_COMPANY]: createSetPropMutation('companyData', {}),
  [types.SET_SCAN_DATA]: createSetPropMutation('scan_data', []),
  [types.CLEAR_SCAN_DATA]: createClearPropMutation('scan_data', []),
  [types.SET_SCAN_DATA_LIST_OPTIONS](state, options = {}) {
    state.scan = {
      ...state.scanDataListOptions || {},
      ...options,
    };
  },
  [types.SET_NEEDED_ACTIONS]: createSetPropMutation('advisedActions', []),
  [types.CLEAR_NEEDED_ACTIONS]: createClearPropMutation('advisedActions', []),
  [types.SET_WORKERS]: createSetPropMutation('workers', []),
  [types.CLEAR_WORKERS]: createClearPropMutation('workers', []),
  [types.SET_WORKERS_LIST_OPTIONS](state, options = {}) {
    state.workerListOptions = {
      ...state.workerListOptions || {},
      ...options,
    };
  },
  [types.SET_WORKER_DETAILS]: createSetPropMutation('workerDetails', {}),
  [types.CLEAR_WORKER_DETAILS]: createClearPropMutation('workerDetails', {}),
  [types.SET_FEATURES]: createSetPropMutation('featureToggles'),
  [types.CLEAR_FEATURES]: createClearPropMutation('featureToggles'),
  [types.SET_LICENSE_DATA]: createSetPropMutation('licenseData', null),
  [types.SET_SYSTEM_SETTINGS]: createSetPropMutation('systemSettings', []),
  [types.CLEAR_SYSTEM_SETTINGS]: createClearPropMutation('systemSettings', []),
  [types.SET_DELETE_USER_LOADING]: createSetPropMutation('deleteUserLoading', false),
  [types.CLEAR_DELETE_USER_LOADING]: createClearPropMutation('deleteUserLoading', false),
  [types.SET_USER_DETAILS_FOR_EDIT]: createSetPropMutation('userDetailsForEdit', {}),
  [types.CLEAR_USER_DETAILS_FOR_EDIT]: createClearPropMutation('userDetailsForEdit', {}),
  [types.SET_NEW_USER_PASSWORD]: createSetPropMutation('newUserPassword', {}),
  [types.CLEAR_NEW_USER_PASSWORD]: createClearPropMutation('newUserPassword', {}),
};
